import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import { chain } from 'lodash'
import Select from 'react-select'
// import { Link as ScrollLink, scroller } from 'react-scroll'
import Helmet from 'react-helmet'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import container from '../../helpers/container'
import config from '../../config'
import {
  ContainerDivs,
  Grade,
  Link,
  LinkIcon,
  SrOnly
} from '../../components'
import Styles from './FundManagers.css'
import imageSocialShare from '../../../static/images/fund-managers-og.png'

@CSSModules(Styles, {allowMultiple:true})
class UssifLogo extends Component {
  render() {
    const ussifLogo = require( '../../../static/images/ussif-icon.png' )
    return (
      <div styleName='ussif-logo-for-table'>
        <img src={ussifLogo} alt='Asset manager has US-SIF member funds'/>
        &nbsp;
        member funds
      </div>
    )
  }
}

@CSSModules(Styles, {allowMultiple:true})
class SriLogo extends Component {
  render() {
    return (
      <div styleName='sri-logo-for-table'>
        <span styleName='sri-logo-for-table-icn'>
          <LinkIcon nospace faclass='fa-leaf'/>
        </span>
        Sustainable fund manager
      </div>
    )
  }
}

@CSSModules(Styles, {allowMultiple:true})
export default class FundManagers extends Component {
  static propTypes = {
    fullGrid: PropTypes.bool
  }
  constructor(props){
    super(props)
    this.state = {
      title: 'Fund managers',
      description: 'The largest fund managers are heavily invested ' +
                   'in arms manufacturers, nuclear weapons, and  ' +
                   'controversial weapons',
      url: config.domain + config.routes.fundManagers,
      top25Filter: 0,
      ussifFilter: 0,
      tableSort: 'assets',
      tableFilter: '',
    }
  }

  setFilter(i, chartType){
    const n = i===this.state[chartType+'Filter'] ? 0 : i
    const newState = {}
    newState[chartType+'Filter'] = n
    this.setState(newState)
  }

  renderFilters = (chartType) => {
    const iconNw = require( '../../../static/images/icn-nw-no-circle-white.svg' )
    const iconCm = require( '../../../static/images/icn-cm-no-circle-white.svg' )
    const iconNwActv = require( '../../../static/images/icn-nw-no-circle-black.svg' )
    const iconCmActv = require( '../../../static/images/icn-cm-no-circle-black.svg' )
    //
    return (
      <div styleName='chart-filters'>
        <div styleName='chart-filters-label'>
          Filters
        </div>
        <div styleName='chart-filters-btn-wrap'>
          <div
            styleName={
              'chart-filters-btn ' + (this.state[chartType+'Filter']===1 ?
                'chart-filters-btn-actv' : '')
            }
            onClick={ () => { this.setFilter(1, chartType) } }
          >
            <img
              src={this.state[chartType+'Filter']===1 ? iconNwActv : iconNw}
              alt='Nuclear weapons' styleName='filter-icn'
            />
            Nuclear weapons
          </div>
          <div
            styleName={
              'chart-filters-btn ' + (this.state[chartType+'Filter']===2 ?
                'chart-filters-btn-actv' : '')
            }
            onClick={() => { this.setFilter(2, chartType) }}
          >
            <img
              src={this.state[chartType+'Filter']===2 ? iconCmActv : iconCm}
              alt='Controversial weapons'
              styleName='filter-icn'
            />
            Controversial weapons
          </div>
        </div>
      </div>
    )
  }

  renderBarChart = (chartType) => {
    // const takeNum = chartType==='ussif' ? 100 : 25
    const takeNum = 25
    return chain(config.familyFunds)
      .filter((f)=>{
        if (chartType === 'ussif') {
          // return f.equity_fund_sri_long_assets / f.equity_fund_long_assets > 0.5
          // return f.num_e_sri / f.num_equity_funds > 0.5
          // return f.num_e_usf > 0
          return f.sustainable_manager
        } else {
          return true
        }
      })
      .sortBy((f)=>{
        return f.equity_fund_net_assets * -1
      })
      .take(takeNum)
      .sortBy((f)=>{
        // const asc = chartType === 'ussif' ? 1 : -1
        const asc = -1
        return f.wff_mil_weight_total * asc
      })
      .map((f,idx) =>{
        const safeName = encodeURIComponent(f.fund_family_name)
        let percFig = null
        let barStyle = null
        switch (this.state[chartType+'Filter']) {
          case 1:
            percFig = 'nw_weight_total'
            barStyle = f.nw_weight_total > 0 ?
              'bar-chart-bar-nw' :
              'bar-chart-bar-nw-0'
            break
          case 2:
            percFig = 'cm_weight_total'
            barStyle = f.cm_weight_total > 0 ?
              'bar-chart-bar-cm' :
              'bar-chart-bar-cm-0'
            break
          default:
            percFig = 'wff_mil_weight_total'
            barStyle = 'bar-chart-bar-'+convert.int(f.grade_military_fam)
            break
        }
        //
        const barElem = <div
          styleName={barStyle}
          style={{
            'width': (f[percFig] * 1000) + '%'
          }}
        />
        //
        const barRemainderElem = this.state[chartType+'Filter'] === 0 ? null : <div
          styleName='bar-chart-bar-outline'
          style={{
            'width': ((f.wff_mil_weight_total - f[percFig]) * 1000) + '%'
          }}
        />
        //
        const figElem = <span styleName='bar-chart-figure'>
          {format.perc(f[percFig])}
        </span>
        //
        return (
          <div
            styleName='bar-chart-row'
            key={'bar-chart-row-'+idx}
          >
            <Link
              to={config.routes.families+'/'+safeName}
              title={f.fund_family_name}
            >
              <Row>
                <Col xs={12} sm={4}>
                  <div styleName='bar-chart-label'>
                    {f.fund_family_label}
                  </div>
                </Col>
                <Col xs={12} sm={8}>
                  <div styleName='bar-chart-bar-wrap'>
                    {barElem}
                    {barRemainderElem}
                    {figElem}
                  </div>
                </Col>
              </Row>
            </Link>
          </div>

        )
      })
      .value()
  }

  getFilteredSortedTable = () => {
    return chain(config.familyFunds)
      .filter((f)=>{
        // check state for filter logic here
        if (this.state.tableFilter && this.state.tableFilter.length > 0) {
          const v = this.state.tableFilter.toUpperCase()
          return f.fund_family_label.toUpperCase().includes(v)
        } else {
          return true
        }
      })
      .sortBy((f)=>{
        // sort by AUM (so ESG/USSIF sorting is also by AUM)
        return f.equity_fund_net_assets * -1
      })
      .sortBy((f)=>{
        const defaultSort = f.equity_fund_net_assets * -1
        let sort = null
        // check state for sort logic here
        switch (this.state.tableSort) {
          case 'name':
            sort = f.fund_family_label.toUpperCase()
            break;
          case 'sri':
            if (f.equity_fund_sri_long_assets / f.equity_fund_long_assets > 0.5) {
              sort = 0
            } else {
              sort = 1
            }
            break;
          case 'ussif':
            if (f.num_e_usf > 0) {
              sort = 0
            } else {
              sort = 1
            }
            break;
          case 'weapons':
            sort = f.wff_mil_weight_total
            break;
          default:
            sort = defaultSort
            break;
        }
        //
        return sort
      })
  }

  renderTable = () => {
    const tableChain = this.getFilteredSortedTable()
    if (tableChain.value().length > 0){
      return tableChain
        .map((c,idx) =>{
          const safeName = encodeURIComponent(c.fund_family_name)
          let round = true
          if (convert.float(c.wff_mil_weight_total,)<1.0) {
            round = false
          }
          const hasUssif = c.num_e_usf > 0
          // const isSri = c.equity_fund_sri_long_assets / c.equity_fund_long_assets > 0.5
          const isSri = c.sustainable_manager
          let borderStyle = ''
          if (isSri) {
            borderStyle = 'sri-row'
          }
          if (hasUssif) {
            borderStyle = 'ussif-row'
          }
          return <div key={idx} styleName='companies-box-wrap'>
            <Link
              log={analytics.eventToFamily(c.fund_family_name)}
              to={config.routes.families+'/'+safeName}
              styleName='companies-link'
              title={c.label}
            >
              <Row styleName={'companies-box ' + borderStyle}>
                <Col styleName='box-title-wrapper' xs={12} sm={4}>
                  <div>
                    <span styleName='box-title'>{c.fund_family_name}</span>
                    { isSri ? <SriLogo /> : null}
                    { hasUssif ? <UssifLogo /> : null}
                  </div>
                </Col>
                <Col xs={3} sm={2} styleName='box-grade-wrap'>
                  <Grade grade={c.grade_military_fam} blocksmall/>
                </Col>
                <Col styleName='box-subtitles' xs={9} sm={4}>
                  { /*
                  {c.num_equity_funds} funds analyzed
                  <br/>
                  {format.money(c.wff_mil_asset_sum, true, 'US Dollar', false, 1)} in military weapon stocks
                  <br/>
                  */ }
                  {format.perc(c.wff_mil_weight_total, round)} military weapon exposure
                </Col>
                <Col styleName='learn-more-wrap' xs={12} sm={2}>
                  More<LinkIcon/>
                </Col>
              </Row>
            </Link>
          </div>
        })
        .value()
    } else {
      return <div>
        <h3>
          Nothing found
        </h3>
      </div>
    }
  }

  render() {
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    const socialShareUrl =  config.domain+imageSocialShare.replace(/.*dist/,'/dist')
    //
    return (
      <div styleName='companies'>
        { container.helmet(this.state.title,
                           this.state.description,
                           this.state.url) }
        <Helmet meta={[
          {property: 'og:image', content: socialShareUrl},
          {property: 'twitter:image', content: socialShareUrl},
        ]}/>
        <div styleName='companies-anchor' id='companies'/>
        <div styleName='lede-wrap'>
          <ContainerDivs>
            <div styleName='lede-h1-wrap'>
              <h1>Fund managers</h1>
            </div>
            <div styleName='lede-nav-flex'>
              <div styleName='lede-p-wrap'>
                <p>
                  <b>Investing in arms manufacturers and military contractors
                  is a risky business.</b> Companies involved in military
                  weapon sales can face a range of economic risks, inluding
                  reputation risk, regulatory risks, and political risks.
                  These risks are amplified when companies are involved with
                  nuclear weapons and controversial weapons like
                  cluster munitions, anti-personnel landmines,
                  incendiary weapons, and depleted uranium. That's why
                  weapon free investing has been a common component of
                  sustainable investing for decades.
                </p>
                <p>
                  <b>But despite these risks, fund managers, including the
                  largest firms responsible for funds found across thousands of
                  corporate 401(k) plans, have significant investments in
                  weapons, including nuclear weapons and controversial
                  weapons.</b>
                </p>
              </div>
            </div>
            <div styleName='lede-ays-logo-wrap'>
              <Link
                to={config.links.ays}
                title='As You Sow'
              >
                <img
                  src={aysLogo}
                  alt='As You Sow'
                  styleName='lede-ays-logo'
                />
                <SrOnly>As You Sow</SrOnly>
              </Link>
            </div>
          </ContainerDivs>
        </div>
        <div styleName='hazard-tape'/>
        <div styleName='chart-background'>
          <ContainerDivs>
            <div styleName='chart-title'>
              Largest fund managers are heavily invested in
              arms manufacturers,
              nuclear weapons,
              and controversial weapons
            </div>
            <div styleName='chart-info'>
              Are your savings invested with one of these financial giants?
              All but one of the top 25 U.S. fund managers* earn a D grade or worse, with
              significant investments in
              arms manufacturers and major military contractors,
              including companies involved with nuclear
              weapons and controversial weapons like cluster munitions,
              anti-personnel landmines, incendiary weapons,
              and depleted uranium.
            </div>
            { this.renderFilters('top25') }
            { this.renderBarChart('top25') }
            <div styleName='chart-disclaimer'>
              * Top 25 asset managers by USD invested in equity funds.
              Universe covers U.S.
              open-end mutual funds
              and exchange-traded funds
              with
              at least 50% of assets directly invested in equities,
              excluding fixed income funds,
              target date fund-of-funds, and
              other alternative investment vehicles
              like collective trusts,
              separately managed accounts,
              or funds domiciled outside the U.S.
            </div>


            <div styleName='chart-title'>
              <span styleName='lt-green'>Sustainable</span> and <span styleName='lt-green'>socially responsible</span> fund managers
              often have less weapons exposure
            </div>
            <div styleName='chart-info'>
              Fund managers that focus on sustainable investing
              have less exposure to military weapons
              on average.
              The top 25 sustainable fund managers<sup>†</sup> earn
              mostly C grades or better,
              with many having no investments in nuclear weapons,
              and almost all avoiding investments in controversial weapons.
            </div>
            { this.renderFilters('ussif') }
            { this.renderBarChart('ussif') }
            <div styleName='chart-disclaimer'>
              <sup>†</sup> Top 25 sustainable fund managers by USD invested.
              "Sustainable fund manager" defined as fund managers with
              at least 50% of assets
              invested in funds with a sustainable investing mandate,
              per Morningstar.
              Universe covers U.S.
              open-end mutual funds
              and exchange-traded funds
              excluding 
              other alternative investment vehicles
              like collective trusts,
              separately managed accounts,
              or funds domiciled outside the U.S.
            </div>
          </ContainerDivs>
        </div>
        <div styleName='hazard-tape'/>
        <ContainerDivs>
          <div styleName='table-title'>
            Over 100 fund managers rated
          </div>
          <div styleName='table-info'>
            Search our database to see how much fund managers
            have invested in companies involved with military weapons.
          </div>
          <div styleName='companies-boxes'>
            <div styleName='table-filters-wrap'>
              <Row>
                <Col xs={8}>
                  <h3 styleName='table-filters-label' htmlFor='table-filter-input'>
                    Search
                  </h3>
                  <div styleName='table-filter-input-wrap'>
                    <input
                      name='table-filter-input'
                      styleName='table-filter-input'
                      value={this.state.tableFilter}
                      type="text"
                      onChange={ (e) => {
                        this.setState({tableFilter: e.target.value})
                      } }
                      placeholder='Search by name...'
                    />
                    <button
                      styleName='search-clear-btn'
                      onClick={ () => {
                        this.setState({tableFilter: ''})
                      } }
                    >
                      <LinkIcon faclass='fa-close' nospace/>
                    </button>
                  </div>
                </Col>
                <Col xs={4}>
                  <h3 styleName='table-filters-label' htmlFor='table-sort-select'>
                    Sort by
                  </h3>
                  <Select
                    name='table-sort-select'
                    value={this.state.tableSort}
                    onChange={(chosen) => {
                      this.setState({tableSort : chosen.value})
                    }}
                    options={[
                      {
                        label: 'Assets, high to low',
                        value: 'assets'
                      },
                      {
                        label: 'Name',
                        value: 'name'
                      },
                      {
                        label: 'Sustainable fund manager',
                        value: 'sri'
                      },
                      {
                        label: 'Has US-SIF member funds',
                        value: 'ussif'
                      },
                      {
                        label: 'Weapon exposure, low to high',
                        value: 'weapons'
                      },
                    ]}
                    clearable={false}
                    searchable={false}
                  />
                </Col>
              </Row>
            </div>
            { this.renderTable() }
          </div>
        </ContainerDivs>
      </div>
    )
  }
}

